<template>
  <label class="block">
    <span class="cursor-pointer text-sm my-1">{{ label }}</span>
    <select
      class="form-select mt-1 block outline-none w-full px-3 py-2 px-2 bg-white border border-gray-300 focus:shadow-outline"
      :value="value" @change="input"
    >
      <slot></slot>
    </select>
    <span v-if="info && !error" class="w-full text-sm text-blue-800 mt-1 mb-0">{{ info }}</span>
    <span v-if="error" class="w-full text-sm text-red-800 mt-1 mb-0">{{ error }}</span>
  </label>
</template>

<script>
export default {
  name: "Select",
  props: {
    value: {
      required: true
    },
    id: {
      required: true
    },
    errors: {
      default: null
    },
    label: {
      default: null
    },
    info: {
      default: null
    },
    disabled: {
      default: false
    }
  },
  computed: {
    error() {
      if (!this.errors) return false
      return this.errors.has(this.id) ? this.errors.first(this.id) : false
    }
  },
  methods: {
    input(e) {
      if (this.errors) this.errors.clear(this.id)
      this.$emit("input", e.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
